<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'userDetail',
})
</script>
<template>
  <div class="main detail-page">
    <a-card>
      <a-spin :spinning="state.loading">
        <div class="card-section-title">用户信息</div>
        <a-row :gutter="[16, 24]">
          <a-col :xs="24" :sm="24" :md="24" :xl="5" class="avatar-col">
            <div class="detail-item detail-item-avatar">
              <a-avatar :size="80" :src="detailInfo.pic || logo" class="user-avatar" />
              <span class="user-nickName">{{ detailInfo.nickname || detailInfo.nickName || '暂无昵称' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="24" :md="24" :xl="15">
            <a-row :gutter="[16, 24]">
              <a-col :xs="24" :sm="24" :md="24" :xl="12">
                <div class="detail-item">
                  <span class="detail-label">用户ID：</span>
                  <span class="detail-value">{{ detailInfo.userNumber || '-' }}</span>
                </div>
              </a-col>
              <a-col :xs="24" :sm="24" :md="24" :xl="12">
                <div class="detail-item">
                  <span class="detail-label">状态：</span>
                  <span class="detail-value">{{ detailInfo.freeze !== undefined ? (detailInfo.freeze == '0' ? '禁用' :
                    '正常') : '-' }}</span>
                </div>
              </a-col>
              <a-col :xs="24" :sm="24" :md="24" :xl="12">
                <div class="detail-item">
                  <span class="detail-label">手机号：</span>
                  <span class="detail-value">{{ detailInfo.tel || '-' }}</span>
                </div>
              </a-col>
              <a-col :xs="24" :sm="24" :md="24" :xl="12">
                <div class="detail-item">
                  <span class="detail-label">创建时间：</span>
                  <span class="detail-value">{{ detailInfo.createTime || '-' }}</span>
                </div>
              </a-col>
            </a-row>
          </a-col>
          <a-col :xs="0" :sm="0" :md="0" :xl="4" class="empty-col"></a-col>
        </a-row>
      </a-spin>
    </a-card>

    <a-card class="mt20">
      <a-spin :spinning="state.loading">
        <div class="card-section-title">店铺信息</div>
        <a-row :gutter="[20, 20]" v-if="detailInfo.storeInfoList && detailInfo.storeInfoList.length > 0">
          <a-col v-for="(shop, index) in detailInfo.storeInfoList" :key="shop.id || index" :xs="24" :sm="24" :md="24" :xl="12">
            <div class="shop-card">
              <img class="shop-back-img" src="@/assets/user/shops_list_back.png" alt="">
              <a-row :gutter="[16, 16]">
                <a-col :span="24">
                  <div class="shop-title">
                    <span class="shop-title-label">店铺名称：</span>
                    <span class="shop-title-value">{{ shop.storeName || '-' }}</span>
                  </div>
                </a-col>
                <a-col :span="24">
                  <div class="detail-item">
                    <span class="detail-label">店铺地址：</span>
                    <span class="detail-value">{{ [shop.addr, shop.detailAddress].filter(Boolean).join('') || '-'
                      }}</span>
                  </div>
                </a-col>
                <a-col :xs="24" :sm="12">
                  <div class="detail-item">
                    <span class="detail-label">店铺类型：</span>
                    <span class="detail-value">{{ shop.storeTypeCode == '1' ? '新开店铺' : shop.storeTypeCode == '2' ?
                      '已有店铺' : '-' }}</span>
                  </div>
                </a-col>
                <a-col :xs="24" :sm="12">
                  <div class="detail-item">
                    <span class="detail-label">店铺面积：</span>
                    <span class="detail-value">{{ shop.buildingArea ? `${shop.buildingArea}㎡` : '-' }}</span>
                  </div>
                </a-col>
                <a-col :xs="24" :sm="12">
                  <div class="detail-item">
                    <span class="detail-label">场所业态类型：</span>
                    <span class="detail-value">{{ shop.venueTypeIdStr || '-' }}</span>
                  </div>
                </a-col>
                <a-col :xs="24" :sm="12">
                  <div class="detail-item">
                    <span class="detail-label">所属行业：</span>
                    <span class="detail-value">{{ shop.industryIdStr || '-' }}</span>
                  </div>
                </a-col>
                <a-col :xs="24" :sm="12">
                  <div class="detail-item">
                    <span class="detail-label">联系人：</span>
                    <span class="detail-value">{{ shop.contactPerson || '-' }}</span>
                  </div>
                </a-col>
                <a-col :xs="24" :sm="12">
                  <div class="detail-item">
                    <span class="detail-label">联系电话：</span>
                    <span class="detail-value">{{ shop.contactPhone || '-' }}</span>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-col>
        </a-row>
        <noData v-else :title="'没有更多数据了'" />
        <div class="detail-footer">
          <a-button class="back-btn" @click="goBack">返回</a-button>
        </div>
      </a-spin>
    </a-card>
  </div>
</template>

<script lang="ts" setup name="userDetail">
import { onMounted, ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useUser } from '@/store/user'
import logo from '@/assets/picLogo.png'
import noData from '@/components/noData/noData.vue'

const router = useRouter()
const route = useRoute()
const userApi = useUser()

const detailInfo = ref<Record<string, any>>({})

const state = reactive({
  loading: false
})

const goBack = () => {
  router.back()
}

onMounted(async () => {
  const params = route.params as { id: string }
  if (!params.id) {
    goBack()
    return
  }
  state.loading = true
  try {
    detailInfo.value = await userApi.getUserDetail(params.id)
  } catch {
    // baseService 已统一提示错误信息
  } finally {
    state.loading = false
  }
})
</script>

<style scoped lang="less">
.detail-page {
  .mt20 {
    margin-top: 20px;
  }

  :deep(.ant-card-body) {
    padding: 24px 28px 28px;
  }

  .card-section-title {
    color: #222;
    font-weight: 400;
    font-size: 22px;
    line-height: 1;
    margin-bottom: 33px;
  }

  .detail-item {
    display: flex;
    align-items: flex-start;
    font-size: 16px;
    line-height: 1.5;

    .detail-label {
      color: #222;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .detail-value {
      color: #222;
      word-break: break-all;
    }
  }

  .avatar-col {
    display: flex;
    align-items: center;
  }

  .detail-item-avatar {
    align-items: center;
    flex-wrap: nowrap;

    .user-avatar {
      flex-shrink: 0;
      border: 2px solid rgba(0, 0, 0, 0.06);
      border-radius: 50%;
    }

    .user-nickName {
      color: #222;
      font-size: 16px;
      margin-left: 8px;
      word-break: break-all;
      line-height: 1.4;
    }
  }

  .empty-col {
    min-height: 1px;
  }

  .shop-card {
    position: relative;
    padding: 24px 28px;
    background: #F4F4F4;

    .shop-back-img {
      position: absolute;
      top: 15px;
      right: 9px;
      width: 116px;
      height: 116px;
    }
  }

  .shop-title {
    padding-bottom: 16px;

    .shop-title-label,
    .shop-title-value {
      font-weight: bold;
      font-size: 20px;
      color: #1E3F70;
    }

    .shop-title-label {
      white-space: nowrap;
    }
  }

  .detail-footer {
    display: flex;
    justify-content: center;
    padding: 40px 0 20px;

    .back-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 97px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #0C418F;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #0C418F;

      &:hover {
        color: #0D479C;
        border-color: #0D479C;
      }
    }
  }
}
</style>
